module.exports = __webpack_public_path__ + "img/voyage_history_lock.7492310c.svg";